export const compareDates = (date) => {
  if (!date) return false;

  return new Date().getTime() < new Date(date).getTime();
};
